import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=038f3862&scoped=true"
import script from "./ticketDetail.vue?vue&type=script&lang=js"
export * from "./ticketDetail.vue?vue&type=script&lang=js"
import style0 from "./ticketDetail.vue?vue&type=style&index=0&id=038f3862&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f3862",
  null
  
)

export default component.exports